module.exports = __webpack_public_path__ + "img/section5-1.0a6f6a47.svg";